/**

**/
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Marionette = require("marionette");
    var template = require('ui.plugins/gridView/filter/filter-types/templates/toggleFilter.tmpl');
    var Logger = require('logger');


    var ToggleFilter = Marionette.ItemView.extend({
        className: "toggle-filter-container",
        template: template,
        ui: {
            buttonTrue: ".filter-toggle-true",
            buttonFalse: ".filter-toggle-false"
        },
        events: {
            "click .filter-toggle-true" : "_onTrueButtonClick",
            "click .filter-toggle-false" : "_onFalseButtonClick"
        },

        initialize: function(options) {
            this.logger = Logger.getLogger("ToggleFilter");
            this.isTrueSelected = false;
            this.isFalseSelected = false;
            this.selected = options.selectedValues || [];

            _.each(this.selected, function (status) {
                if (status === true) {
                    this.isTrueSelected = true;
                }
                if (status === false) {
                    this.isFalseSelected = true;
                }
            }, this);

            if(options.filterData){
                this.trueTitle = options.filterData.trueTitle || "";
                this.falseTitle = options.filterData.falseTitle || "";
            }
            else{
                this.logger.error("Missing filterData","ToggleFilter:initialize");
                this.logger.graph({ name: "UIComponents:ToggleFilter:MissingFilterData"});
            }
        },

        onRender: function() {
            this._setButtonsState(this.isTrueSelected, this.isFalseSelected);
        },

        customTemplateHelpers : function () {
            return {
                trueTitle: this.trueTitle,
                falseTitle: this.falseTitle
            };
        },

        _onFalseButtonClick: function(){
            this.isFalseSelected = !this.isFalseSelected;
            this.ui.buttonFalse.toggleClass("selected", this.isFalseSelected);
        },

        _onTrueButtonClick: function(){
            this.isTrueSelected = !this.isTrueSelected;
            this.ui.buttonTrue.toggleClass("selected", this.isTrueSelected);
        },

        _setButtonsState: function(isTrueSelected, isFalseSelected) {
            this.isTrueSelected = isTrueSelected;
            this.isFalseSelected = isFalseSelected;
            this.ui.buttonFalse.toggleClass("selected", this.isFalseSelected);
            this.ui.buttonTrue.toggleClass("selected", this.isTrueSelected);
        },

        getFilterSelection: function() {
            var selectedValues = [];

            if (this.isTrueSelected){
                selectedValues.push(true);
            }
            if (this.isFalseSelected){
                selectedValues.push(false);
            }

            return selectedValues;
        },

        resetCollectionFilter: function() {
            this._setButtonsState(false, false);
            return this.getFilterSelection();
        }
    });

    return ToggleFilter;
});
